import {PriorCourseUnit} from "./PriorCourseUnit";

export class PriorCourse {
    public country: string;
    public institution: any;
    public tempInstitution: string;
    public courseName: string;
    public yearCompleted: number;
    public units: PriorCourseUnit[] = [];
    public index: number;
}





// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/model/PriorCourse.ts